export default "__VITE_ASSET__fq5z294p__"